// extracted by mini-css-extract-plugin
export default {"title":"dvCmS","sub-title":"b6Fkq","item":"AtXJT","content":"nX6FX","icon":"uUSzv"};